import { useEffect, useState } from 'react';

import AdminLayout from '../../components/admin/AdminLayout';
import { ResponsiveTable } from '../../components/admin/responsive';
import { api } from '../../services/api';

const STATUS_LABEL = {
  PENDING_REVIEW: {
    label: 'Aguardando revisão',
    color: '#f59e0b',
    bg: '#fef3c7',
  },
  APPROVED: { label: 'Aprovado', color: '#10b981', bg: '#d1fae5' },
  REJECTED: { label: 'Reprovado', color: '#ef4444', bg: '#fee2e2' },
};

const REG_STATUS = {
  CONFIRMED: { label: 'Confirmada', color: '#10b981' },
  PENDING: { label: 'Pendente', color: '#f59e0b' },
  CANCELLED: { label: 'Cancelada', color: '#ef4444' },
};

export default function Comprovantes() {
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('');
  const [modal, setModal] = useState(null); // { item, previewOpen }
  const [decisao, setDecisao] = useState('');
  const [notaAdmin, setNotaAdmin] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    carregar();
  }, []);

  async function carregar() {
    setLoading(true);
    try {
      const res = await api.get('/admin/comprovantes');
      setLista(res.data);
    } catch {
      setLista([]);
    } finally {
      setLoading(false);
    }
  }

  async function salvarDecisao() {
    if (!decisao) return;
    setSalvando(true);
    try {
      const res = await api.patch(
        `/admin/comprovantes/${modal.item.id}/revisar`,
        {
          decisao,
          nota: notaAdmin || undefined,
        },
      );
      const linkGerado = res.data?.paymentLink ?? null;
      setFeedback({
        tipo: 'ok',
        msg:
          decisao === 'APPROVED'
            ? `Aprovado! Link enviado por email.${linkGerado ? ` Link: ${linkGerado}` : ''}`
            : 'Comprovante reprovado.',
        link: linkGerado,
      });
      setModal(null);
      await carregar();
    } catch (e) {
      setFeedback({
        tipo: 'erro',
        msg: e?.response?.data?.error ?? 'Erro ao salvar.',
      });
    } finally {
      setSalvando(false);
    }
  }

  const lista_filtrada = lista.filter(
    (i) =>
      !filtro ||
      i.nome.toLowerCase().includes(filtro.toLowerCase()) ||
      i.email.toLowerCase().includes(filtro.toLowerCase()) ||
      i.cpf.includes(filtro),
  );

  const pendentes = lista.filter(
    (i) => i.comprovanteStatus === 'PENDING_REVIEW',
  ).length;

  return (
    <AdminLayout>
      {/* Header */}
      <div style={S.header}>
        <div>
          <h1 style={S.h1}>Comprovantes Sociais</h1>
          <p style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>
            Inscrições de Ingresso Social aguardando revisão de comprovante
          </p>
        </div>
        {pendentes > 0 && (
          <div
            style={{
              background: '#fef3c7',
              border: '1px solid #fcd34d',
              borderRadius: 12,
              padding: '10px 16px',
              fontSize: 13,
              fontWeight: 800,
              color: '#92400e',
            }}
          >
            ⏳ {pendentes} aguardando revisão
          </div>
        )}
      </div>

      {/* Feedback */}
      {feedback && (
        <div
          style={{
            background: feedback.tipo === 'ok' ? '#d1fae5' : '#fee2e2',
            border: `1px solid ${feedback.tipo === 'ok' ? '#6ee7b7' : '#fca5a5'}`,
            borderRadius: 10,
            padding: '10px 16px',
            fontSize: 13,
            fontWeight: 700,
            color: feedback.tipo === 'ok' ? '#065f46' : '#991b1b',
            marginBottom: 16,
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: 12,
            }}
          >
            <div>
              <div>
                {feedback.tipo === 'ok' && feedback.link
                  ? 'Aprovado! Link enviado por email.'
                  : feedback.msg}
              </div>
              {feedback.link && (
                <div style={{ marginTop: 6, fontSize: 12, fontWeight: 600 }}>
                  <span style={{ color: '#065f46' }}>Link gerado: </span>
                  <a
                    href={feedback.link}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: '#059669',
                      textDecoration: 'underline',
                      wordBreak: 'break-all',
                    }}
                  >
                    {feedback.link}
                  </a>
                  <button
                    onClick={() => navigator.clipboard.writeText(feedback.link)}
                    style={{
                      marginLeft: 8,
                      background: '#059669',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 6,
                      padding: '2px 8px',
                      fontSize: 11,
                      cursor: 'pointer',
                      fontWeight: 700,
                    }}
                  >
                    Copiar
                  </button>
                </div>
              )}
            </div>
            <button
              onClick={() => setFeedback(null)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                opacity: 0.6,
                flexShrink: 0,
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* Search */}
      <div style={{ marginBottom: 20 }}>
        <input
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          placeholder="Buscar por nome, email ou CPF..."
          style={{
            padding: '10px 16px',
            borderRadius: 12,
            border: '1px solid #e2e8f0',
            fontSize: 13,
            width: '100%',
            maxWidth: 380,
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />
      </div>

      {/* Table */}
      {loading ? (
        <div
          style={{
            textAlign: 'center',
            padding: 48,
            color: '#94a3b8',
            fontSize: 13,
          }}
        >
          Carregando...
        </div>
      ) : (
        <ResponsiveTable
          data={lista_filtrada}
          columns={[
            {
              key: 'nome',
              label: 'Nome',
              render: (_, row) => (
                <div>
                  <div
                    style={{ fontWeight: 700, color: '#0f172a', fontSize: 13 }}
                  >
                    {row.nome}
                  </div>
                  <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                    {row.whatsapp}
                  </div>
                </div>
              ),
            },
            {
              key: 'cpf',
              label: 'CPF',
              render: (_, row) => (
                <span style={{ fontFamily: 'monospace', fontSize: 12 }}>
                  {row.cpf}
                </span>
              ),
            },
            {
              key: 'email',
              label: 'Email',
              render: (_, row) => (
                <span style={{ fontSize: 12, color: '#334155' }}>
                  {row.email}
                </span>
              ),
            },
            {
              key: 'evento',
              label: 'Evento',
              render: (_, row) => (
                <span style={{ fontSize: 12, color: '#334155' }}>
                  {row.evento}
                </span>
              ),
            },
            {
              key: 'status',
              label: 'Pag.',
              render: (_, row) => {
                const regSt = REG_STATUS[row.status] ?? {
                  label: row.status,
                  color: '#94a3b8',
                };
                return (
                  <div>
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: regSt.color,
                      }}
                    >
                      {regSt.label}
                    </span>
                    <div
                      style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}
                    >
                      {(row.valorCentavos / 100).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </div>
                  </div>
                );
              },
            },
            {
              key: 'comprovante',
              label: 'Comprovante',
              render: (_, row) => {
                const isPdf =
                  row.comprovanteMimeType === 'application/pdf' ||
                  row.comprovanteUrl?.toLowerCase().endsWith('.pdf');
                return (
                  <div>
                    {row.comprovanteUrl ? (
                      <a
                        href={row.comprovanteUrl}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          color: '#3b82f6',
                          fontWeight: 700,
                          fontSize: 12,
                          textDecoration: 'none',
                        }}
                      >
                        {isPdf ? '📄 Ver PDF' : '🖼 Ver imagem'}
                      </a>
                    ) : (
                      <span style={{ color: '#94a3b8', fontSize: 12 }}>
                        Sem arquivo
                      </span>
                    )}
                    {row.comprovanteObservacao && (
                      <div
                        style={{
                          fontSize: 11,
                          color: '#64748b',
                          marginTop: 4,
                          maxWidth: 160,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                        title={row.comprovanteObservacao}
                      >
                        "{row.comprovanteObservacao}"
                      </div>
                    )}
                  </div>
                );
              },
            },
            {
              key: 'comprovanteStatus',
              label: 'Status doc.',
              render: (_, row) => {
                const docSt =
                  STATUS_LABEL[row.comprovanteStatus] ??
                  STATUS_LABEL.PENDING_REVIEW;
                return (
                  <span
                    style={{
                      background: docSt.bg,
                      color: docSt.color,
                      fontSize: 11,
                      fontWeight: 800,
                      padding: '4px 10px',
                      borderRadius: 99,
                      display: 'inline-block',
                    }}
                  >
                    {docSt.label}
                  </span>
                );
              },
            },
            {
              key: 'actions',
              label: 'Ações',
              render: (_, row) => (
                <button
                  onClick={() => {
                    setModal({ item: row });
                    setDecisao('');
                    setNotaAdmin('');
                  }}
                  style={{
                    padding: '6px 14px',
                    border: 'none',
                    borderRadius: 8,
                    fontSize: 12,
                    fontWeight: 700,
                    cursor: 'pointer',
                    background: '#f1f5f9',
                    color: '#475569',
                  }}
                >
                  Revisar
                </button>
              ),
            },
          ]}
          options={{
            emptyMessage: 'Nenhuma inscrição social encontrada.',
          }}
        />
      )}

      {/* Modal de revisão */}
      {modal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,.45)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 50,
            padding: '16px',
          }}
          onClick={() => setModal(null)}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 20,
              padding: 28,
              width: '100%',
              maxWidth: 540,
              boxShadow: '0 20px 60px rgba(0,0,0,.15)',
              maxHeight: '90vh',
              overflowY: 'auto',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2
              style={{
                fontSize: 18,
                fontWeight: 900,
                color: '#0f172a',
                margin: '0 0 8px',
              }}
            >
              Revisar comprovante
            </h2>
            <p style={{ fontSize: 13, color: '#64748b', marginBottom: 16 }}>
              <strong>{modal.item.nome}</strong> — {modal.item.email}
            </p>

            {modal.item.comprovanteUrl && (
              <div style={{ marginBottom: 16 }}>
                {modal.item.comprovanteMimeType === 'application/pdf' ||
                modal.item.comprovanteUrl.toLowerCase().endsWith('.pdf') ? (
                  <a
                    href={modal.item.comprovanteUrl}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6,
                      background: '#eff6ff',
                      color: '#1d4ed8',
                      padding: '8px 14px',
                      borderRadius: 10,
                      fontWeight: 700,
                      fontSize: 13,
                      textDecoration: 'none',
                    }}
                  >
                    📄 Abrir PDF
                  </a>
                ) : (
                  <img
                    src={modal.item.comprovanteUrl}
                    alt="Comprovante"
                    style={{
                      maxWidth: '100%',
                      borderRadius: 12,
                      maxHeight: 280,
                      objectFit: 'contain',
                      border: '1px solid #f1f5f9',
                    }}
                  />
                )}
              </div>
            )}

            {modal.item.comprovanteObservacao && (
              <div
                style={{
                  background: '#f8fafc',
                  borderRadius: 10,
                  padding: '10px 14px',
                  fontSize: 13,
                  color: '#475569',
                  marginBottom: 16,
                  fontStyle: 'italic',
                }}
              >
                "{modal.item.comprovanteObservacao}"
              </div>
            )}

            <label
              style={{
                display: 'block',
                fontSize: 10,
                fontWeight: 900,
                color: '#94a3b8',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                marginBottom: 8,
              }}
            >
              Decisão
            </label>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns:
                  window.innerWidth < 480 ? '1fr' : '1fr 1fr',
                gap: 10,
                marginBottom: 16,
              }}
            >
              {['APPROVED', 'REJECTED'].map((d) => (
                <button
                  key={d}
                  type="button"
                  onClick={() => setDecisao(d)}
                  style={{
                    padding: '12px 16px',
                    borderRadius: 10,
                    border: `2px solid ${decisao === d ? (d === 'APPROVED' ? '#10b981' : '#ef4444') : '#e2e8f0'}`,
                    background:
                      decisao === d
                        ? d === 'APPROVED'
                          ? '#d1fae5'
                          : '#fee2e2'
                        : '#fff',
                    color:
                      decisao === d
                        ? d === 'APPROVED'
                          ? '#065f46'
                          : '#991b1b'
                        : '#64748b',
                    fontWeight: 800,
                    fontSize: 12,
                    cursor: 'pointer',
                    transition: 'all .15s',
                    minHeight: '44px',
                  }}
                >
                  {d === 'APPROVED' ? '✓ Aprovar' : '✕ Reprovar'}
                </button>
              ))}
            </div>

            <label
              style={{
                display: 'block',
                fontSize: 10,
                fontWeight: 900,
                color: '#94a3b8',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                marginBottom: 8,
              }}
            >
              Nota interna (opcional)
            </label>
            <textarea
              value={notaAdmin}
              onChange={(e) => setNotaAdmin(e.target.value)}
              placeholder="Ex: CadÚnico válido, aprovado."
              rows={3}
              style={{
                width: '100%',
                padding: '12px 16px',
                borderRadius: 10,
                border: '1px solid #e2e8f0',
                fontSize: 16,
                fontFamily: 'inherit',
                resize: 'vertical',
                boxSizing: 'border-box',
                marginBottom: 16,
                minHeight: '100px',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#ff2d6c')}
              onBlur={(e) => (e.target.style.borderColor = '#e2e8f0')}
            />

            <div
              style={{
                display: 'grid',
                gridTemplateColumns:
                  window.innerWidth < 480 ? '1fr' : '1fr 1fr',
                gap: 12,
                justifyContent: 'flex-end',
              }}
            >
              <button
                type="button"
                onClick={() => setModal(null)}
                style={{
                  padding: '12px 24px',
                  background: '#f8fafc',
                  color: '#475569',
                  border: '1px solid #e2e8f0',
                  borderRadius: 10,
                  fontSize: 12,
                  fontWeight: 700,
                  cursor: 'pointer',
                  minHeight: '44px',
                  transition: 'background-color 0.2s',
                }}
                onMouseEnter={(e) => (e.target.style.background = '#f1f5f9')}
                onMouseLeave={(e) => (e.target.style.background = '#f8fafc')}
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={salvarDecisao}
                disabled={!decisao || salvando}
                style={{
                  padding: '12px 24px',
                  background: '#ff2d6c',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 10,
                  fontSize: 12,
                  fontWeight: 900,
                  cursor: salvando || !decisao ? 'not-allowed' : 'pointer',
                  opacity: !decisao ? 0.5 : 1,
                  minHeight: '44px',
                  transition: 'background-color 0.2s',
                }}
                onMouseEnter={(e) =>
                  !salvando &&
                  decisao &&
                  (e.target.style.background = '#e02059')
                }
                onMouseLeave={(e) => (e.target.style.background = '#ff2d6c')}
              >
                {salvando ? 'Salvando...' : 'Confirmar decisão'}
              </button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}

const S = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 28,
    flexWrap: 'wrap',
    gap: 12,
  },
  h1: { fontSize: 22, fontWeight: 900, color: '#0f172a', margin: 0 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: {
    textAlign: 'left',
    padding: '10px 14px',
    color: '#94a3b8',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    borderBottom: '1px solid #f1f5f9',
    background: '#fafafa',
  },
  td: { padding: '12px 14px', color: '#334155', verticalAlign: 'top' },
  btnPrimary: {
    padding: '9px 18px',
    background: '#ff2d6c',
    color: '#fff',
    border: 'none',
    borderRadius: 99,
    fontSize: 12,
    fontWeight: 900,
    cursor: 'pointer',
  },
  btnSecondary: {
    padding: '9px 18px',
    background: '#f8fafc',
    color: '#475569',
    border: '1px solid #e2e8f0',
    borderRadius: 99,
    fontSize: 12,
    fontWeight: 700,
    cursor: 'pointer',
  },
  btnSmall: {
    padding: '6px 14px',
    border: 'none',
    borderRadius: 8,
    fontSize: 12,
    fontWeight: 700,
    cursor: 'pointer',
  },
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 50,
  },
  modalBox: {
    background: '#fff',
    borderRadius: 20,
    padding: 28,
    width: '100%',
    maxWidth: 540,
    boxShadow: '0 20px 60px rgba(0,0,0,.15)',
    maxHeight: '90vh',
    overflowY: 'auto',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: 900,
    color: '#0f172a',
    margin: '0 0 8px',
  },
  label: {
    display: 'block',
    fontSize: 10,
    fontWeight: 900,
    color: '#94a3b8',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginBottom: 6,
  },
};
